<template>
    <div>
        <component-setting v-for="prop in visibleProps.filter(x => !x.section)" :key="prop.name" v-model="config.props[prop.name]" :prop="prop" :config="config" @input="$emit('save')" />

        <v-expansion-panels accordion flat >
            <v-expansion-panel v-for="section in propSections" :key="section.name">
                <v-expansion-panel-header class="pa-0">
                    <h2>{{$translate(section.name)}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <component-setting v-for="prop in section.props" :key="prop.name" v-model="config.props[prop.name]" :prop="prop" :config="config" @input="$emit('save')" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import components from '../component.js';
import ComponentSetting from './ComponentSetting.vue'
export default {
    name: 'zoezi-component-props-setting',

    props: {
        config: Object
    },

    components: {
        ComponentSetting
    },

    computed: {
        cprops() {
            return this.config ? components.getComponentProps(this.config.component) : [];
        },
        visibleProps() {
            return this.cprops.filter(prop => {
                if (!prop.typeinfo?.visible) {
                    return true;
                }

                let vprop = prop.typeinfo?.visible;
                let neg = vprop[0] == '!';
                if (neg) {
                    vprop = vprop.substring(1);
                }
                let value = this.config.props[vprop]
                return neg ? !value : !!value;
            });
        },
        propSections() {
            let sections = [];
            this.visibleProps.filter(x => x.section).forEach(prop => {
                let section = sections.find(sx => sx.name == prop.section);
                if (!section) {
                    section = {name: prop.section, props: []}
                    sections.push(section);
                }
                section.props.push(prop);
            });
            return sections;
        }
    }
}
</script>
